import { useMutation } from "@tanstack/react-query";
import { upsertSharingApi } from "@/api/services/main/sharing";
import { TUpsertSharingReqDto } from "@/api/services/main/sharing/dtos/sharing.dto";
import { toast } from "@/utils/toast";
import { showError } from "@/utils/error";
import { API_SUCCESS_MESSAGE } from "@/constants/common";

export const useUpdateSharePassword = () => {
  return useMutation({
    mutationFn: ({ caseId, payload }: { caseId: number | string; payload: TUpsertSharingReqDto }) =>
      upsertSharingApi("case", caseId, payload),
    onSuccess: () => {
      toast.success(API_SUCCESS_MESSAGE);
    },
    onError: (error: unknown) => {
      showError(error);
    },
  });
};
